import { configureStore } from "@reduxjs/toolkit";
import adminReducer from "./slices/adminSlice";
import collectionsReducer from "./slices/collectionsSlice";
import brandsShowcaseReducer from "./slices/brandsShowcaseSlice";
import uiContentReducer from "./slices/uiContentSlice";
import authReducer from "./slices/authSlice";

export const store = configureStore({
  reducer: {
    admin: adminReducer,
    collections: collectionsReducer,
    brandsShowcase: brandsShowcaseReducer,
    uiContent: uiContentReducer,
    auth: authReducer,
  },
});

export default store;
